module.exports = new __parcel__URL__("logo_milieu_marin.4fba1df3.png").toString();